import * as dayjs from 'dayjs'
import moment from 'moment'
import url from '../url'

function plugin(Vue) {

    if (plugin.installed) {
      return
    }
    Vue.prototype.baseUrl=url
    Vue.prototype.hasPermission=function(permissionName){
        return window.abp.auth.hasPermission(permissionName)
    }
    Vue.prototype.hasAnyOfPermissions=function(permissionName){
      return window.abp.auth.hasAnyOfPermissions(permissionName)
    }
    Vue.prototype.hasAllOfPermissions=function(permissionName){
      return window.abp.auth.hasAllOfPermissions(permissionName)
    }
    Vue.prototype.L=function (key, sourceName) {
      sourceName = sourceName || window.abp.localization.defaultSourceName

      var source = window.abp.localization.values[sourceName]

      if (!source) {
          return key
      }

      var value = source[key]
      if (value == undefined) {
          return key
      }

      var copiedArguments = Array.prototype.slice.call(arguments, 0)
      copiedArguments.splice(1, 1)
      copiedArguments[0] = value

      return window.abp.utils.formatString.apply(this, copiedArguments)
    },
    Vue.prototype.datestr=function(date){
      return dayjs(date).format('YYYY-MM-DD')
    },
    Vue.prototype.datetimestr=function(date){
      return dayjs(date).format('YYYY-MM-DD HH:mm:ss')
    },
    Vue.prototype.moment=moment
  }
  
  export default plugin